import { http } from '@/http/axios.js'
export function getHomeStatAPI(params) {
  return http({
    url: '/admin/bi/dashboard',
    method: 'get',
    params
  })
}
